// Main Slider

jQuery("#main-banner-carousel").owlCarousel({
    autoplay: true,
    lazyLoad: true,
    loop: true,
    margin: 0,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    touchDrag  : true,
    mouseDrag  : true,
    responsiveClass: true,
    autoHeight: true,
    autoplayTimeout: 5000,
    smartSpeed: 500,
  	autoplayHoverPause:true,
    nav: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="17.348" height="13.515" viewBox="0 0 17.348 13.515"><path id="Path_1" data-name="Path 1" d="M268,391.033H252.271l5.756,5.75a.373.373,0,1,1-.528.528l-6.38-6.385a.326.326,0,0,1-.046-.057.216.216,0,0,1-.017-.028l-.018-.037-.011-.037a.15.15,0,0,1,0-.031.364.364,0,0,1,0-.144.15.15,0,0,1,0-.031l.011-.037.018-.037a.214.214,0,0,1,.017-.028.325.325,0,0,1,.046-.057l6.38-6.385a.369.369,0,0,1,.522-.006l.006.006a.369.369,0,0,1,0,.522h0l-5.756,5.756H268a.369.369,0,1,1,0,.739Z" transform="translate(-251.019 -383.905)" fill="#030504"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="17.348" height="13.515" viewBox="0 0 17.348 13.515"> <path id="Path_2" data-name="Path 2" d="M251.388,391.033h15.727l-5.756,5.75a.373.373,0,0,0,.528.528l6.38-6.385a.326.326,0,0,0,.046-.057.216.216,0,0,0,.017-.028l.018-.037.011-.037a.15.15,0,0,0,0-.031.364.364,0,0,0,0-.144.15.15,0,0,0,0-.031l-.011-.037-.018-.037a.214.214,0,0,0-.017-.028.325.325,0,0,0-.046-.057l-6.38-6.385a.369.369,0,0,0-.522-.006l-.006.006a.369.369,0,0,0,0,.522h0l5.756,5.756H251.388a.369.369,0,1,0,0,.739Z" transform="translate(-251.019 -383.905)" fill="#030504"/> </svg>',
    ],
    dots: true,
    responsive: {
      0: {
        items: 1
      },
  
      767: {
        items: 1
      },
  
      991: {
        items: 1
      },
  
      1200: {
        items: 1
      }
    }
});

// Product Slider

$(document).ready(function($) {
    $('.product-main-images').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      fade: false,
      infinite: false,
      accessibility: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="9.172" height="16.984" viewBox="0 0 9.172 16.984"><path id="Path_13" data-name="Path 13" d="M126.721,8.026,118.866.192a.658.658,0,1,0-.93.932l7.388,7.367-7.388,7.367a.658.658,0,0,0,.93.932l7.855-7.833a.658.658,0,0,0,0-.932Z" transform="translate(126.915 16.984) rotate(180)"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="9.172" height="16.984" viewBox="0 0 9.172 16.984"><path id="Path_12790" data-name="Path 12790" d="M8.978,8.958,1.123,16.791a.658.658,0,0,1-.93-.932L7.581,8.492.193,1.124a.658.658,0,0,1,.93-.932L8.978,8.026a.658.658,0,0,1,0,.932Z"/></svg></button>',
      asNavFor: '.product-thumb-images'
    });
    
    $('.product-thumb-images').slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      asNavFor: '.product-main-images',
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="31.062" height="16.776" viewBox="0 0 31.062 16.776"><g id="svgexport-17_48_" data-name="svgexport-17 (48)" transform="translate(0 134.518) rotate(-90)"><path id="Path_13" data-name="Path 13" d="M134.164,14.679,119.8.351a1.2,1.2,0,0,0-1.7,1.705l13.512,13.475L118.1,29.006a1.2,1.2,0,0,0,1.7,1.7l14.367-14.327a1.2,1.2,0,0,0,0-1.7Z"/></g></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16.776" height="31.062" viewBox="0 0 16.776 31.062"><path id="Path_13" data-name="Path 13" d="M134.164,14.679,119.8.351a1.2,1.2,0,0,0-1.7,1.705l13.512,13.475L118.1,29.006a1.2,1.2,0,0,0,1.7,1.7l14.367-14.327a1.2,1.2,0,0,0,0-1.7Z" transform="translate(-117.742 0)"/></svg></button>',
      infinite: false,
      vertical: true,
      autoplay: false,
      centerPadding: "0px",
      adaptiveHeight: true,
      centerMode: false,
      focusOnSelect: true
    });
});

// PhotoSwipe

(function($) {

  // Init empty gallery array
  let galleryArray = [];

  // Loop over gallery items and push it to the array
  $('.gallery').find('figure').each(function() {
    var $link = $(this).find('a'),
      item = {
        src: $link.attr('href'),
        w: $link.data('width'),
        h: $link.data('height'),
        title: $link.attr('title') 
      };
    galleryArray.push(item);
  });
	
	console.log(galleryArray);
  
  // Define click event on gallery item
  $('.open-galley').click(function(event) {

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
      options = {
        index: $(this).parent('figure').index(),
        bgOpacity: 0.85,
        showHideOpacity: true
      };
    
    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, galleryArray, options);
    gallery.init();
  });

}(jQuery));

// Footer

$(document).ready(function($) {

  // Footer Accordioan
    if ($(window).width() < 767) {
       $('.footer-block__heading').click(function () {
        $(this).parent().find('.ft-nav').toggleClass("ft-nav-show");
        $(this).parent().find('.fa-chevron-down').toggleClass("arrow-up");
        $(this).parent().siblings().find('.ft-nav').removeClass("ft-nav-show");
        $(this).parent().siblings().find('.fa-chevron-down').removeClass("arrow-up");
    });
  }
    
});

// Product Detail Page Tabs

$(document).ready(function($) {
  
    const tabs = document.querySelectorAll('.product-tabs-nav li a');
    const tabContents = document.querySelectorAll('.product-tab');
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Deactivate all tabs
        tabs.forEach((t) => t.parentElement.classList.remove('active'));
        // Hide all tab contents
        tabContents.forEach((c) => c.style.display = 'none');
        
        // Activate the clicked tab
        tab.parentElement.classList.add('active');
        // Show the corresponding tab content
        tabContents[index].style.display = 'block';
      });
    });
  
});

// Product Detail Page Accordioan

$(document).ready(function(){
  $('.product__accordion details').on('click',function(){
    $(this).attr('open');
    $(this).parent('.product__accordion').siblings().find('details').removeAttr('open');
  });
});

// Swiper Slider

// Initialize Swiper instances with distinct variable names
var swiper1 = new Swiper(".swiper-container", {
  effect: "cards",
  grabCursor: true,
  slidesPerView: "auto",
  initialSlide: 0,
  centeredSlides: false,
  spaceBetween: 20,
  loop: false,
  cardsEffect: {
    rotate: 0,
    stretch: 0,
    depth: 200,
    modifier: 200,
    slideShadows: false,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

var swiper2 = new Swiper(".swiper-container-luxe", {
  effect: "cards",
  grabCursor: true,
  slidesPerView: "auto",
  initialSlide: 0,
  centeredSlides: false,
  spaceBetween: 20,
  loop: false,
  cardsEffect: {
    rotate: 0,
    stretch: 0,
    depth: 200,
    modifier: 200,
    slideShadows: false,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Function to update the counter
function updateCounter(swiperInstance, counterSelector) {
  var activeIndex = swiperInstance.realIndex + 1; // Start from 1
  var totalSlides = swiperInstance.slides.length;
  var counterText = activeIndex + " | " + totalSlides;
  document.querySelector(counterSelector).textContent = counterText;
}

// Function to update the progress bar for the first swiper instance
function updateProgressBarForSwiper1(swiperInstance) {
  // Calculate the progress percentage
  var progress = (swiperInstance.activeIndex / (swiperInstance.slides.length - 1)) * 100;
  // Update the width of the progress bar element for swiper 1
  var progressBar = swiperInstance.el.querySelector(".swiper-progress .progress-bar-1");
  progressBar.style.width = progress + "%";
}

// Function to update the progress bar for the second swiper instance (or others)
function updateProgressBar(swiperInstance) {
  // Calculate the progress percentage
  var progress = (swiperInstance.activeIndex / (swiperInstance.slides.length - 1)) * 100;
  // Update the width of the progress bar element for swiper 2
  var progressBar = swiperInstance.el.querySelector(".swiper-progress .progress-bar-2");
  progressBar.style.width = progress + "%";
}

// Initial update of the counter and progress bar for both instances
updateCounter(swiper1, ".custom-pagination");
updateCounter(swiper2, ".custom-pagination-2");

// Update the counter and progress bar when the slide changes for both instances
swiper1.on("slideChange", function () {
  updateCounter(swiper1, ".custom-pagination");
  updateProgressBarForSwiper1(swiper1);
});

swiper2.on("slideChange", function () {
  updateCounter(swiper2, ".custom-pagination-2");
  updateProgressBar(swiper2);
});
